import * as React from "react";
import {BarChart, BarChartRow} from "../../../locations/marketing/charts/BarChart";
import {Loader} from "../../../components/Utils/loader/Loader";
import {Display} from "../../../components/Display";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {EmptyState, icons, infoIcons} from "@vebox/etui-core";
import {DATA_STATE} from "../../contexts/UsersDashboardContext";
import {Legend, LegendItem} from "../../../components/charts/Legend";
import {CountDaysWithLogin} from "./CountDaysWithLogin";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {useUserDetails} from "../../contexts/UserDetailsContext";
import {createBarChartData, getLegend} from "../../../types/UsersManagementTypes";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;


export const DaysWithLoginSection: React.FC = () => {

    const [barChartData, setBarChartData] = React.useState<BarChartRow[]>([])
    const [legendItems, setLegendItems] = React.useState<LegendItem[]>([]);
    const [selectedElement, setSelectedElement] = React.useState();
    const [isEmpty, setIsEmpty] = React.useState(false);
    const [, , , usersAccessesByDayState] = useUserDetails();
    const {userAccessesByDayData, state} = usersAccessesByDayState;

    React.useEffect(() => {
        if (state === DATA_STATE.loaded) {
            if (userAccessesByDayData.usersLogging.length === 0 && userAccessesByDayData.usersNotLogging === 0) {
                setIsEmpty(true);
            } else {
                setBarChartData(createBarChartData(userAccessesByDayData.usersLogging))
                setLegendItems(getLegend(AppTranslations.usersManagement.dayWithUserActivity))
                setIsEmpty(false);
            }
        }
    }, [userAccessesByDayData]);

    return (
        <VeBoxCard className={"Section"}>
            <VeBoxCard.Header
                title={AppTranslations.usersManagement.daysWithUserActivityTitle}
                singleLineTitle={true}
            />
            <VeBoxCard.Body className={"detail-card"}>
                <Display isVisible={state === DATA_STATE.isLoading}>
                    <Loader/>
                </Display>
                <Display isVisible={state === DATA_STATE.loaded}>
                    <Display isVisible={!isEmpty}>
                        <div className="cards-container">
                            <div className="padding-bottom-10px">
                                <CountDaysWithLogin
                                    data={userAccessesByDayData}
                                />
                            </div>
                            <div className="widget-content">
                                <div className="user-management-chart-legend">
                                    <Legend
                                        items={legendItems}
                                        selectedItemName={selectedElement}
                                        onItemHover={setSelectedElement}
                                        showValues={false}
                                    />
                                </div>
                                <AutoSizer disableHeight style={{width: "auto"}}>
                                    {({width}) => {
                                        return (
                                            <BarChart
                                                width={width}
                                                height={300}
                                                color={null}
                                                data={barChartData}
                                                yUnitOfMeasure={""}
                                                minYScaleValue={1}
                                                onPathOver={setSelectedElement}
                                                selectedItem={selectedElement}
                                                labelsOptions={{externalLegend: true}}
                                                withYScaleValues={false}
                                                withFrequencyField={false}
                                            />
                                        )
                                    }
                                    }
                                </AutoSizer>
                            </div>
                        </div>
                    </Display>
                    <Display isVisible={isEmpty}>
                        <div className={"vertical-align-center"}>
                            <EmptyState>
                                <EmptyState.InfoIcon
                                    styles={{
                                        root: {
                                            color: "var(--empty-indicator-svg-stroke)",
                                        }
                                    }}
                                    glyph={infoIcons.NoContent}
                                />
                                <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                                <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                            </EmptyState>
                        </div>
                    </Display>
                </Display>
                <Display isVisible={state === DATA_STATE.error}>
                    <EmptyState>
                        <EmptyState.Icon size={144} glyph={icons.ERROR_CIRCLE}/>
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.errorMessages.errorTitle}</EmptyState.Title>
                        <EmptyState.SubTitle color="inherit">
                            {AppTranslations.errorMessages.tryAgainLaterMessage}
                        </EmptyState.SubTitle>
                    </EmptyState>
                </Display>
            </VeBoxCard.Body>
        </VeBoxCard>
    )
}